import { useQuery } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { RootTemplate } from '~/components/templates/RootTemplate';
import { useAuth } from '~/lib/auth';

export const LogOutRoute: React.FC = () => {
  const { logOut } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const query = useQuery({
    queryFn: () =>
      logOut({
        openUrl: (url) => navigate(url),
        nextUrl: searchParams.get('nextUrl') || '/sessions',
      }),
  });

  return (
    <RootTemplate>{query.isLoading ? 'Loging out...' : null}</RootTemplate>
  );
};
